export default __webpack_public_path__ + "static/media/lehenga1.f548ccc9.jpg";